module.exports = __webpack_public_path__ + "img/q28.93a3df4c.jpg";